module.exports = __webpack_public_path__ + "img/minting.53046c38.webp";